<template>
  <div style="width: 100%">
    <el-table :data="dataList" border style="width: 100%">
      <el-table-column
          type="index"
          label="行号"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="receiptCode"
          label="出口发票号"
          header-align="center"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="shipDate"
          label="装船日期"
          header-align="center"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          label="外销合同号"
          prop="agreementCode"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column label="品番号" prop="code" align="center" width="160">
        </el-table-column>
        <el-table-column label="品名" prop="name" align="center" width="160">
        </el-table-column>
        <el-table-column label="颜色" prop="color" align="center" width="80">
        </el-table-column>
        <el-table-column label="规格" prop="size" align="center" width="100">
        </el-table-column>
        <el-table-column
          label="出货数量"
          prop="totalCount"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          label="出货工厂"
          prop="factoryName"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          label="每箱入数"
          prop="preBoxCount"
          align="center"
          width="60"
        >
        </el-table-column>
        <el-table-column
          label="箱数"
          header-align="center"
          align="center"
          width="60"
          prop="boxCount"
        >
        </el-table-column>
        <el-table-column label="纸箱尺寸" header-align="center">
          <el-table-column
            label="长(cm)"
            header-align="center"
            align="center"
            width="80"
            prop="boxLong"
          >
          </el-table-column>
          <el-table-column
            label="宽(cm)"
            header-align="center"
            align="center"
            width="80"
            prop="boxWidth"
          >
          </el-table-column>
          <el-table-column
            label="高(cm)"
            header-align="center"
            align="center"
            width="80"
            prop="boxHeight"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="单箱体积(m³)"
          header-align="center"
          align="center"
          width="110"
          prop="preSize"
        >
        </el-table-column
        ><el-table-column
          label="总体积(m³)"
          header-align="center"
          align="center"
          width="100"
          prop="totalSize"
        >
        </el-table-column>
        <el-table-column
          label="毛重(kg)"
          header-align="center"
          align="center"
          width="100"
          prop="weight"
        >
        </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  name: "order-box",
  mixins: [mixinViewModule],
  components: {},
  props: {
    agreementId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/boxform/page",
        getDataListIsPage: true,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: "",
      },
    };
  },
  watch: {
    agreementId: {
      handler: function(newVal) {
        if (newVal && newVal !== "") {
          this.dataForm.agreementId = newVal;
          this.reload();
        } else {
          this.dataList = [];
        }
      },
      immediate: true,
    },
  },
  methods: {},
};
</script>
